import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Lookups, Race, RaceStartDateType, RaceStartItem, RaceStartType } from "@model";
import { AbstractComponent } from "../abstract.component";

@Component({
    selector: 'races-to-start-cancel-edit-modal',
    templateUrl: './races-to-start-cancel-edit-modal.component.html',
    styleUrls: ['./races-to-start-cancel-edit-modal.component.scss'],
    standalone: false
})
export class RacesToStartCancelEditModalComponent extends AbstractComponent implements OnInit {
  @Input() listOfRaces?: Race[];
  @Input() title?: string;
  @Input() confirmButtonTitle?: string;
  @Input() dismissButtonTitle?: string;
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() raceStartDateType:RaceStartDateType = RaceStartDateType.START as RaceStartDateType;

  startOnlyRdy = false;
  selectedRaceStartItem?: RaceStartItem;
  selectedRadioButton?: string;

  inputForm = new FormGroup({
    time: new FormControl(),
  });

  constructor(public activeModal: NgbActiveModal, public formBuilder: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.listOfRaces?.forEach(race => race.raceStartItems?.forEach(item => item.selected = false));
    if (this.raceStartDateType === RaceStartDateType.EDIT) this.initFormControls();
  }

  private initFormControls() {
    this.inputForm.controls.time.valueChanges.subscribe(time => {
      if (this.selectedRaceStartItem && time) {
        this.selectedRaceStartItem.started = time;
        this.inputForm.updateValueAndValidity();
      }
    });
    this.inputForm.controls.time.disable();
    this.inputForm.updateValueAndValidity();
  }

  onConfirmClick(): void {
    if (this.raceStartDateType === RaceStartDateType.START) this.setStartDate();
    if (this.raceStartDateType === RaceStartDateType.STOP) this.deleteStartDate();
    if (this.raceStartDateType === RaceStartDateType.EDIT) this.selectAllItems();
    this.activeModal.close({
      startOnlyCompetitorsPresentOnStart: this.startOnlyRdy,
      races: this.listOfRaces?.filter(race => this.isAnyRaceItemSelected(race)).map(race => ({
        id: race.id,
        eventId: race.eventId,
        raceStartItems: race.raceStartItems?.filter(item => item.selected),
        edited: this.raceStartDateType === RaceStartDateType.EDIT
      })),
      raceStartDateType:this.raceStartDateType
    });
  }

  private setStartDate() {
    const sysdate = new Date();
    this.listOfRaces?.forEach(race => race.raceStartItems?.forEach(item => {
      if (item.selected) item.started = sysdate;
    }));
  }

  private deleteStartDate() {
    this.listOfRaces?.forEach(race => race.raceStartItems?.forEach(item => {
      if (item.selected) item.started = undefined;
    }));
  }

  private selectAllItems() {
    this.listOfRaces?.forEach(race => race.raceStartItems?.forEach(item => {
      item.selected = true;
      item.edited = true;
    }));
  }

  onDismissClick = () => this.activeModal.dismiss();

  isAnyRaceSelected = () => this.listOfRaces?.some(race => this.isAnyRaceItemSelected(race)) ?? false;

  private isAnyRaceItemSelected = (race: Race) => race.raceStartItems?.some(item => item.selected) ?? false;

  onSelect = (raceStartItem: RaceStartItem) => {
    this.selectedRaceStartItem = raceStartItem;
    if (this.inputForm.controls.time.disabled) this.inputForm.controls.time.enable();
    this.inputForm.controls.time.setValue(raceStartItem.started);
    this.inputForm.updateValueAndValidity();
  };

  protected readonly RaceStartType = RaceStartType;
  protected readonly RaceStartDateType = RaceStartDateType;
  protected readonly Race = Race;
}
